import React from 'react';

interface WetRoadsRegularIconProps {
  className?: string;
}

function WetRoadsRegularIcon(props: WetRoadsRegularIconProps) {
  const { className = '' } = props;
  return (
    <svg
      className={className}
      fill="none"
      height={15}
      viewBox="0 0 15 13"
      width={15}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.803571 0C1.24888 0 1.60714 0.358259 1.60714 0.803571V2.07254C1.60714 3.18415 1.93527 4.26897 2.55134 5.19308L3.60603 6.77679C4.39955 7.9654 4.82143 9.36161 4.82143 10.7879V12.0536C4.82143 12.4989 4.46317 12.8571 4.01786 12.8571C3.57254 12.8571 3.21429 12.4989 3.21429 12.0536V10.7846C3.21429 9.67299 2.88616 8.58817 2.27009 7.66406L1.2154 6.08371C0.421875 4.89509 0 3.49888 0 2.07254V0.803571C0 0.358259 0.358259 0 0.803571 0ZM11.7857 0.803571V2.07254C11.7857 3.18415 12.1138 4.26897 12.7299 5.19308L13.7846 6.77679C14.5781 7.9654 15 9.36161 15 10.7879V12.0536C15 12.4989 14.6417 12.8571 14.1964 12.8571C13.7511 12.8571 13.3929 12.4989 13.3929 12.0536V10.7846C13.3929 9.67299 13.0647 8.58817 12.4487 7.66406L11.394 6.08036C10.6004 4.89509 10.1786 3.49888 10.1786 2.07254V0.803571C10.1786 0.358259 10.5368 0 10.9821 0C11.4275 0 11.7857 0.358259 11.7857 0.803571Z"
        fill="#121213"
      />
    </svg>
  );
}

export default WetRoadsRegularIcon;
